let token      = document.head.querySelector('meta[name="csrf-token"]');
module.exports = {
    props: ['user', 'team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({}),
            uploadingPhoto: false
            // server: {
            //     process: (fieldName, file, metadata, load, error, progress) => {
            //         const formData = new FormData();
            //         formData.append('file', file, file.name);
            //         formData.append('type', fieldName);
            //
            //         const request = new XMLHttpRequest();
            //
            //         request.open('POST', '/settings/upload-header-footer-image');
            //         request.setRequestHeader('X-CSRF-TOKEN', token.content);
            //
            //         request.upload.onprogress = (e) => {
            //             progress(e.lengthComputable, e.loaded, e.total);
            //         };
            //         request.onload            = function () {
            //             if (request.status >= 200 && request.status < 300) {
            //                 let response     = JSON.parse(request.response);
            //                 load(request.responseText);
            //             } else {
            //                 error('oh no');
            //             }
            //         };
            //         request.send(formData);
            //         setTimeout(() => {
            //             window.location.reload(true);
            //         }, 2000);
            //     }
            // },
            // headerSwitch:(this.team.header_image_show == 1)? true:false,
            // footerSwitch:(this.team.footer_image_show == 1)? true:false,
            // headerImage: (this.team.header_image_url)? this.team.header_image_url+'?'+Math.floor(Math.random() * 11):null,
            // footerImage: (this.team.footer_image_url)? this.team.footer_image_url+'?'+Math.floor(Math.random() * 11):null,
            // imageType:''
        };
    },

    methods: {
        /**
         * Update the team's photo.
         */
        update(e) {
            e.preventDefault();

            if ( ! this.$refs.photo.files.length) {
                return;
            }


            var self = this;
            const userTeam = _.findIndex(self.user.teams, {id: self.team.id});
            const userRole = self.user.teams[userTeam].pivot.role;
            self.form.startProcessing();
            self.uploadingPhoto = true;
            // We need to gather a fresh FormData instance with the profile photo appended to
            // the data so we can POST it up to the server. This will allow us to do async
            // uploads of the profile photos. We will update the user after this action.
            axios.post(self.urlForUpdate, self.gatherFormData())
                .then(
                    ({response}) => {
                        Bus.$emit('updateTeam');
                        Bus.$emit('updateTeams');

                        self.fireSuccessToast('Company Profile Updated.');
                        self.form.finishProcessing();
                        self.uploadingPhoto = false;
                    },
                    (error) => {
                        console.log(error)
                        self.uploadingPhoto = false;
                        self.form.setErrors(error.response.data.errors);
                    }
                );
        },


        /**
         * Gather the form data for the photo upload.
         */
        gatherFormData() {
            const data = new FormData();

            data.append('photo', this.$refs.photo.files[0]);

            return data;
        },

        /**
         * Delete Header or Footer Image of Team.
         */
        // deleteImage(type){
        //
        //     axios.post('/settings/delete-header-footer-image', {
        //         type: type
        //     }).then(
        //             (response) => {
        //                 Bus.$emit('updateTeam');
        //                 Bus.$emit('updateTeams');
        //                 this.fireSuccessToast(response.data.message);
        //                 this.form.finishProcessing();
        //                 if(type == "header_image_url"){
        //                     this.headerImage = null;
        //                 }else{
        //                     this.footerImage = null;
        //                 }
        //             },
        //             (error) => {
        //                 self.form.setErrors(error.response.data.errors);
        //             }
        //         );
        // },


        fireSuccessToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'success',
                title: message,
            });
        },
        fireErrorToast(message) {
            const Toast = Swal.mixin({
                toast            : true,
                position         : 'top-end',
                showConfirmButton: false,
                timer            : 2000
            });

            Toast.fire({
                type : 'error',
                title: message,
            });
        },

        // headerSwitchUpdate(){
        //     this.$nextTick(()=>{
        //
        //         var data = {
        //           'type':'header',
        //           'show': (this.headerSwitch)? 1:0
        //         };
        //
        //         axios.post('/settings/update-header-footer-image-show', data).then(
        //             (response) => {
        //                 Bus.$emit('updateTeam');
        //                 Bus.$emit('updateTeams');
        //                 this.fireSuccessToast(response.data.message);
        //             }
        //         );
        //     });
        // },

        // footerSwitchUpdate(){
        //     this.$nextTick(()=>{
        //
        //         var data = {
        //             'type':'footer',
        //             'show': (this.footerSwitch)? 1:0
        //         };
        //
        //         axios.post('/settings/update-header-footer-image-show', data).then(
        //             (response) => {
        //                 Bus.$emit('updateTeam');
        //                 Bus.$emit('updateTeams');
        //                 this.fireSuccessToast(response.data.message);
        //             }
        //         );
        //     });
        // },

        // openImageCropperModal(typeImage){
        //     this.imageType = typeImage;
        //     $('#uploadAndCropImage').modal('show');
        // }
    },


    computed: {
        /**
         * Get the URL for updating the team photo.
         */
        urlForUpdate() {
            return `/settings/${Spark.teamsPrefix}/${this.team.id}/photo`;
        },


        /**
         * Calculate the style attribute for the photo preview.
         */
        previewStyle() {
            return `background-image: url(${this.team.photo_url})`;
        }
    }
};
